import { useEffect, useState } from 'react';
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface TextFieldFilterRowShadcnProps {
    valueField: string;
    handleChangeTextValueField: (value: string) => void;
}

export default function TextFieldFilterRowShadcn({ valueField, handleChangeTextValueField }: TextFieldFilterRowShadcnProps) {
    const [updateTimeout, setUpdateTimeout] = useState<NodeJS.Timeout>();
    const [value, setValue] = useState<string>(valueField);
    const [isLoading, setIsLoading] = useState(false);

    const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const targetValue = e.target.value;
        setIsLoading(true);
        setValue(targetValue);
        
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }

        const newTimeout = setTimeout(() => {
            handleChangeTextValueField(targetValue);
            setIsLoading(false);
        }, 1500);

        setUpdateTimeout(newTimeout);
    };

    useEffect(() => {
        setValue(valueField);
    }, [valueField]);

    return (
        <div className="relative w-full">
            <Input
                name="results"
                value={value ?? valueField ?? ''}
                autoComplete="off"
                onChange={handleTextFieldChange}
                className="w-full h-9 pr-8" // Standardized height
            />
            {isLoading && (
                <div className="absolute right-2 top-1/2 -translate-y-1/2">
                    <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
                </div>
            )}
        </div>
    );
}
